import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Configurations, Button } from '@hpstellar/core';
import { MetricsElement } from 'react-metrics';

import ConfigurationDrawer from '../../../ui/components/configuration-drawer';
import { Helpers } from '../../../core/src/helpers';

import { getSelectedVariant, getConfigurations } from './utils';
import SuppliesCard from './supplies-card';

import './similar-supplies.less';

const reduceProductList = Helpers.memoize(
    (sku, similarSupplies) => {
        return similarSupplies.reduce((r, group) => {
            return r.concat(group.products);
        }, []);
    },
    (sku, similarSupplies) => {
        return `${sku}-${(similarSupplies || []).length}`;
    },
);

const onChange = (sku, history, isOpen, closeDrawer, trackCustomMetric, configurations) => value => {
    const selectedVariant = getSelectedVariant(configurations, value);
    const { value: configCatentryId, salePrice, regularPrice } = selectedVariant || {};
    closeDrawer(false);
    try {
        let label = configurations.find(c => c && c.value === value).configName;
        trackCustomMetric('linkClick', {
            event: 'e_linkClick',
            linkPlacement: 'product',
            linkId: `similar-supplies-picker-${label}`,
        });
    } catch (e) {}

    if (value.indexOf('/us-en/shop/pdp/') > -1) {
        history.push(Helpers.getRelativePath(value));
    } else {
        window.location.href = value;
    }
};

export default ({
    productInitial,
    drawerPosition = 'right',
    pdpSimilarSupplies,
    label = 'Selected options',
    ctaText = 'Modify',
    trackCustomMetric,
}) => {
    const [isOpen, closeDrawer] = useState(false);
    const history = useHistory();
    const { similarSupplies } = pdpSimilarSupplies || {};
    if (!productInitial || !similarSupplies || similarSupplies.length < 1) {
        return null;
    }
    const { sku } = productInitial;
    const products = reduceProductList(sku, similarSupplies);
    const selectedVariant = getConfigurations([productInitial])[0];
    const modalClose = () => closeDrawer(false);
    return (
        <>
            <Configurations
                className="configComp"
                dividerPosition="top"
                label={label}
                content={selectedVariant.name}
                tally={products.length > 0 ? `(${products.length} more available)` : undefined}
                action={
                    <MetricsElement
                        element="span"
                        data-metrics-event="e_linkClick"
                        data-metrics-link-placement="product"
                        data-metrics-link-id={`similar-supplies-picker-${selectedVariant.value}`}
                    >
                        <Button size={'small'} variation="tertiary" onClick={() => closeDrawer(!isOpen)}>
                            {ctaText}
                        </Button>
                    </MetricsElement>
                }
            />
            <ConfigurationDrawer
                title="Choose Your Option"
                isOpen={isOpen}
                onClose={modalClose}
                className="similar-supplies"
                drawerPosition={drawerPosition}
            >
                {similarSupplies.map(group => {
                    const { products, name } = group;
                    const configurations = getConfigurations(products);
                    return (
                        <SuppliesCard
                            title={name}
                            options={configurations}
                            onChange={onChange(sku, history, isOpen, closeDrawer, trackCustomMetric, configurations)}
                            modalClose={modalClose}
                        />
                    );
                })}
            </ConfigurationDrawer>
        </>
    );
};
